import { L } from '@lang';
import { Button, ButtonGroup, classNames } from '@vkontakte/vkui';
import { CustomText } from '../CustomText';
import { StoreBlock } from '../StoreBlock';
import { useMainState } from './hooks';
import { HeaderContent } from '../HeaderContent';
import { TitleImage } from '../TitleImage';
import { AboutSection } from '../AboutSection';
import { ContestFinishingSection } from '../ContestFinishingSection';
import { HeaderLayout } from '../HeaderLayout';
import styles from './Main.module.css';

export function Main() {
  const { deviceType, contestFinishingSection, aboutSection, storeSection } = useMainState();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const textWeight = deviceType === 'mobile' ? '1' : '2';

  return (
    <div className={classNames(styles.root, styles[`root__${deviceType}`])}>
      <HeaderLayout>
        <HeaderContent deviceType={deviceType} />
      </HeaderLayout>

      {contestFinishingSection && (
        <ContestFinishingSection
          titleComponent={
            <div style={{ padding: '0 var(--vkui--size_base_padding_horizontal--regular)' }}>
              <TitleImage type={contestFinishingSection.type} deviceType={deviceType} />
            </div>
          }
          buttonGroupContent={contestFinishingSection.buttons.map((buttonProps) => (
            <Button key={buttonProps.id} data-testid="finishig-section-button" {...buttonProps} />
          ))}
          mode={deviceType === 'mobile' ? 'vertical' : 'horizontal'}
          subtitle={
            <CustomText Component="h3" weight={textWeight}>
              {contestFinishingSection.subtitle}
            </CustomText>
          }
          deviceType={deviceType}
        />
      )}

      <AboutSection
        title={<TitleImage type="about" deviceType={deviceType} />}
        subtitle={
          <CustomText Component="h3" weight={textWeight}>
            {aboutSection.subtitle}
          </CustomText>
        }
        text={
          <CustomText Component="p" weight={textWeight}>
            {aboutSection.text}
          </CustomText>
        }
        imageUrl={aboutSection.imageUrl}
      />

      <StoreBlock getRootRef={storeSection.sentinelStoreBlockRef} />

      <ButtonGroup align="center" className={styles.buttonGroup} stretched mode="vertical">
        <Button mode="secondary" appearance="neutral" size="l" stretched onClick={scrollToTop}>
          {L.t('crush_landing_move_top_button_text')}
        </Button>
      </ButtonGroup>
    </div>
  );
}
